import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import ITLeasingConnectPanel from '../../module/benefits/itLeasing/ITLeasingConnectPanel';

import { useITLeasingPrecondition } from '../../module/benefits/itLeasing/useITLeasingPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

export const ITLeasingSettingsPage: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const { isPreconditionMet, PreconditionComponent } = useITLeasingPrecondition();

  return (
    <AuthorizedLayout title={t('IT_LEASING.settings.title')} breadcrumbs={[{ title: t('IT_LEASING.title'), to: '/benefits/it_leasing' }]}>
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.ItLeasing)}
        title={t('IT_LEASING.title')}
        subTitle={t('IT_LEASING.settings.title')}
      >
        {isPreconditionMet ? (
          <BenefitPaper sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <ITLeasingConnectPanel />
          </BenefitPaper>
        ) : (
          <BenefitPaper>{PreconditionComponent}</BenefitPaper>
        )}
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default ITLeasingSettingsPage;
